export const ROLE_TYPES = {
  POINT_OF_CONTACT: 'Point of Contact',
  CLIENT: 'Client',
  CARER: 'Carer',
  SUPERADMIN: 'Superadmin',
  ADMIN: 'Admin',
  MANAGER: 'Manager',
  CARE_COORDINATOR: 'Care Coordinator',
  FIELD_SUPERVISOR: 'Field Supervisor'
} as const;

export const AGENCY_ROLES = [
  ROLE_TYPES.SUPERADMIN,
  ROLE_TYPES.ADMIN,
  ROLE_TYPES.MANAGER,
  ROLE_TYPES.CARE_COORDINATOR,
  ROLE_TYPES.FIELD_SUPERVISOR
] as const;

// Roles with full access (bypass permission checks)
export const POWER_ROLES = ['superadmin', 'admin'] as const;

// Category permission mappings for the reports page
export const REPORT_CATEGORY_PERMISSIONS: Record<string, string> = {
  operations: 'reports.operations',
  finance: 'reports.finance',
  workforce: 'reports.workforce',
  'client-quality': 'reports.client-quality',
  executive: 'reports.executive',
  docezy: 'reports.document-compliance'
} as const;

// Reports has no single "reports.access" permission — the backend grants it per category, so holding
// any one of these opens the page and the sidebar then shows only the categories that key allows.
export const REPORT_PERMISSION_KEYS = Object.values(REPORT_CATEGORY_PERMISSIONS);

export const PERMISSION_ROUTE_MAP: Record<string, string> = {
  'dashboard.access': '/agency/home',
  'clients.access': '/agency/clients/list',
  'carers.access': '/agency/carers/list',
  'rota.access': '/agency/rota/client-rota',
  'schedule.access': '/agency/schedule/list-view',

  // Reports has no .access key, so each category permission points at the page itself — without
  // these a reports-only user lands on /not-authorized after signing in.
  ...Object.fromEntries(REPORT_PERMISSION_KEYS.map(key => [key, '/agency/reports']))
};

// Tab permission mappings for client detail pages
export const CLIENT_TAB_PERMISSIONS: Record<string, string> = {
  profile: 'client.profile.read',
  'care-plans': 'client.careplan.read',
  'daily-task': 'client.dailytask.read',
  medication: 'client.medications.read',
  visit: 'client.appointments.read',
  emar: 'client.emar.read',
  absence: 'client.absence.read',
  contacts: 'client.contacts.read',
  'carer-ratings': 'client.carer.ratings.read',
  notes: 'client.notes.read',
  'activity-log': 'client.activitylog.read',
  'share-client-data': 'clients.share-data.read'
} as const;

// Tab permission mappings for carer detail pages
export const CARER_TAB_PERMISSIONS: Record<string, string> = {
  profile: 'carer.profile.read',
  absence: 'carer.absence.read',
  notes: 'carer.notes.read',
  'activity-log': 'carer.activitylog.read'
} as const;
